// import { fromJS } from 'immutable';
import { COMMENT } from './actionTypes';
import { CHANGED, ERROR, FORM_HIDE, FORM_SHOW, REMOVE, START, SUCCESS } from '../../consts';

import api from '../../apiSingleton';

export function showCommentForm (data) {
  return {
    type: COMMENT + FORM_SHOW,
    payload: data
  };
}

export function hideCommentForm () {
  return {
    type: COMMENT + FORM_HIDE
  };
}

export function createComment (text, isPublic = false) {
  return (dispatch, getState) => {
    const state = getState();
    const comment = prepareComment(state, text, isPublic);

    return restComment(dispatch, 'commentCreate', comment);
  };
}

export function updateComment (text, isPublic = false) {
  return (dispatch, getState) => {
    const state = getState();
    const comment = prepareComment(state, text, isPublic);

    return restComment(dispatch, 'commentUpdate', comment);
  };
}

export function removeComment (comment) {
  return (dispatch, getState) => {
    const comment = getState().getIn(['comments', 'form']);

    return restComment(dispatch, 'commentRemove', comment);
  };
}

function prepareComment (state, text, isPublic) {
  return state.getIn(['comments', 'form'])
    .remove('open')
    .remove('process')
    .merge({
      text: text.trim(),
      isPublic: isPublic ? 1 : 0
    });
}

function restComment (dispatch, operation, comment) {
  dispatch({
    type: COMMENT + START
  });

  return api.user[operation](comment.toJS())
    .then((data) => {
      if (operation === 'commentRemove') {
        dispatch({
          type: COMMENT + REMOVE,
          payload: comment.get('realtyId')
        });
      } else {
        dispatch({
          type: COMMENT + CHANGED,
          payload: data
        });
      }

      dispatch(hideCommentForm());

      return dispatch({
        type: COMMENT + SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      return dispatch({
        type: COMMENT + ERROR,
        payload: err.messages
      });
    });
}



// WEBPACK FOOTER //
// ./src/app/Comments/actions.js